//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import moment from 'moment';
//@end

// @import configs
// @end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import ForumLocationService from 'app_services/admin/forum/forumLocationService'
import ForumCategoryService from 'app_services/admin/forum/forumCategoryService'
// @end

// @INFO Import Styles
import './../forumModule.scss'
import ForumTagsService from 'app_services/admin/forum/forumTagsService';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';

// @ADD Component types
interface IForumModuleLayoutProps {
  onHandleSubmit: (data: any) => void
  editData?: any
  viewer: boolean
  defaultLocation?: 'student' | 'teacher' | 'guest'
}

const ForumModuleLayout: React.FC<IForumModuleLayoutProps> = (props) => {

	const forumLocationService: ForumLocationService = new ForumLocationService()
  const forumCategoryService: ForumCategoryService = new ForumCategoryService()
  const forumTagsService: ForumTagsService = new ForumTagsService()

  const [isActive, setIsActive] = useState<boolean>(false)
  const [listOfForumLocation, setListOfForumLocation] = useState<Array<any>>([])
  const [listOfForumCategory, setListOfForumCategory] = useState<Array<any>>([])
  const [listOfForumTags, setListOfForumTags] = useState<Array<any>>([])
  const [setValueLocation, updateSetValueLocation] = useState<any>({})

  const { t } = useTranslation()
  const formHook = useForm()

  useEffect(() => {
    if (props?.editData) {
      setIsActive((props?.editData?.details?.isActive) ? props?.editData?.details?.isActive : false)
    }
  }, [props,props.editData])

  useEffect(() => {
    getForumCategories()
    getForumLocations()
    getForumTags()
  }, [])

  useEffect(() => {
    if (listOfForumLocation?.length && props.defaultLocation) {
      const _location = listOfForumLocation.find((l) => l.label === props.defaultLocation)
      if (_location) {
        updateSetValueLocation({location: [_location]});
      }
    }
  }, [listOfForumLocation])

  const getForumCategories = async () => {
    const categories: Array<any> = []
    const forumCategoriesResponse = await forumCategoryService.list()
    if (forumCategoriesResponse) {
      forumCategoriesResponse.forumCategories.map((type: any) => {
        categories.push({ value: type._id, label: type.name })
      })
    }
    setListOfForumCategory(categories)
  }

  const getForumLocations = async () => {
    const locations: Array<any> = []
    const forumLocationsResponse = await forumLocationService.list()
    if (forumLocationsResponse) {
      forumLocationsResponse.forumLocations.map((type: any) => {
        locations.push({ value: type._id, label: type.name })
      })
    }
    setListOfForumLocation(locations)
  }

  const getForumTags = async () => {
    const tags: Array<any> = []
    const forumTagsResponse = await forumTagsService.list()
    if (forumTagsResponse) {
      forumTagsResponse.forumTags.map((type: any) => {
        tags.push({ value: type._id, label: type.name })
      })
    }
    setListOfForumTags(tags)
  }

  const handleChangeIsActive = (e: any) => {
    setIsActive(!isActive)
  }

  const handleSubmitForm = (data: any) => {
    const newData = {...data};
    if (setValueLocation?.location) {
      const _location = setValueLocation.location[0];
      newData.locations = [_location];
    }
    props.onHandleSubmit(newData);
  }

  return(
    <div className='forum-form'>

      <fieldset disabled={props.viewer ? true : false}>
        <form onSubmit={formHook.handleSubmit(handleSubmitForm)}>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.forums.general_information")}</h3>
          </div>

          <div className="row">
            <div className="col-md-12 switch-is-active">
              <div className="form-group">
                <Form.Check
                  type='switch'
                  id='isActive'
                  name='isActive'
                  label={t('labels.forums.isActive')}
                  onChange={(event: any) => handleChangeIsActive(event)}
                  checked={isActive}
                  ref={formHook.register()}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='postDate'>{t('labels.forums.postDate')}</label>
                <input
                  type='date'
                  className='form-control'
                  name='postDate'
                  defaultValue={moment.utc(props?.editData?.details?.postDate).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                  ref={formHook.register({ required: true })}
                />
                {formHook.errors.postDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            {!props.defaultLocation ?
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='locations'>{t('labels.forums.locations')}</label>
                <ReactSelectComponent
                  identifier='locations'
                  options={listOfForumLocation}
                  formHooks={formHook}
                  defaultValue={(props?.editData?.details?.locations) ? props?.editData?.details?.locations.map((r: any) => {return {value: r.forumLocation._id, label: r.forumLocation.name}}) : []}
                  isMulti={true}
                  required={true}
                />
                {formHook.errors.locations && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>
            :null}
          </div>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.forums.forum_configuration")}</h3>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className='form-group '>
                <label htmlFor='title'>{t('labels.forums.title')}</label>
                {formHook.errors.title && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='title'
                  name='title'
                  className={`form-control ${formHook.errors.title && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details?.title}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='description'>{t('labels.forums.description')}</label>
                {formHook.errors.description && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <textarea
                  id="description"
                  name="description"
                  className={`form-control ${formHook.errors.title && 'is-invalid'}`}
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details?.description}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className='form-group'>
                <label htmlFor='cover'>{t('labels.forums.cover')}</label>
                {formHook.errors.cover && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='cover'
                  name='cover'
                  className='form-control-file'
                  type='file'
                  ref={formHook.register({ required: false })}
                />
                {formHook.errors.cover && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>
            {props?.editData?.details?.coverUrl && (
              <div className="col-md-6">
                <div className="form-group">
                    <div className="cover-container">
                      <img src={props?.editData?.details?.coverUrl} alt=""/>
                    </div>
                </div>
              </div>
            )}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='category'>{t('labels.forums.category')}</label>
                <ReactSelectComponent
                  identifier='category'
                  isCreatable={false}
                  options={listOfForumCategory}
                  formHooks={formHook}
                  defaultValue={(props?.editData?.details?.category) ? [{label: props?.editData?.details?.category?.name, value: props?.editData?.details?.category._id}] : undefined}
                  isMulti={false}
                  required={false}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                {/* <label htmlFor='tags'>{t('labels.forums.tags')}</label> */}
                <TextComponent
                  type='text'
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: 400,
                    color:'black'
                  }}
                  helpText='Las etiquetas son palabras sirven para dar más información sobre el tema a tratar en el foro.'
                >
                  {t('labels.forums.tags')}
                </TextComponent>
                <ReactSelectComponent
                  identifier='tags'
                  isCreatable={true}
                  options={listOfForumTags}
                  formHooks={formHook}
                  defaultValue={(props?.editData?.details?.tags) ? props?.editData?.details?.tags.map((r: any) => {return {value: r._id, label: r.name}}) : []}
                  isMulti={true}
                  required={false}
                />
              </div>
            </div>
          </div>

          {!props.viewer && (
            <div className='buttons-group'>
              <div className='text-right'>
                <button className='btn btn-primary' type='submit'>
                  {t('buttons.save')}
                </button>
              </div>
            </div>
          )}

        </form>
      </fieldset>
    </div>
  )
}

export default ForumModuleLayout
